import { useMutation, useQuery, UseQueryOptions } from 'react-query';
import { useServices } from '../../../services/useServices';

// Local DTOs so this data-layer hook stays self-contained and does not depend
// on the ArrangeColumnsModal (UI-layer) types.
export interface IColumnPreferencesData {
  order: string[];
  hidden: string[];
}

interface IColumnPreferencesResponse {
  success: boolean;
  data: IColumnPreferencesData | null;
}

interface ISaveColumnPreferencesParams extends IColumnPreferencesData {
  table_id: string;
}

type TColumnPreferencesQueryOptions = Omit<
  UseQueryOptions<IColumnPreferencesData | null>,
  'queryKey' | 'queryFn'
> & { isOpen?: boolean };

export const useGetColumnPreferences = (
  tableId: string,
  options?: TColumnPreferencesQueryOptions
) => {
  const {
    book: { brendaColumnPreferences }
  } = useServices();

  const { isOpen, ...queryOptions } = options ?? {};

  return useQuery<IColumnPreferencesData | null>(
    ['brenda-column-preferences', tableId],
    async () => {
      const response: IColumnPreferencesResponse = await brendaColumnPreferences('get', {
        table_id: tableId
      });

      return response?.success ? response.data : null;
    },
    {
      enabled: Boolean(tableId) && isOpen !== false,
      refetchOnWindowFocus: false,
      staleTime: 10 * 60 * 1000, // 10 minutes
      ...queryOptions
    }
  );
};

export const useSaveColumnPreferences = () => {
  const {
    book: { brendaColumnPreferences }
  } = useServices();

  return useMutation((params: ISaveColumnPreferencesParams) =>
    brendaColumnPreferences('save', params)
  );
};
